/**
 * Region config from config-platform (via ezy-bff cache).
 * Fetched at app startup; used to override locale defaults (e.g. business.fiscalIdFormat).
 */

import { getAuthConfig } from "./auth";

export type RegionConfig = {
  business?: {
    fiscalIdFormat?: {
      cpf?: string;
      cnpj?: string;
    };
  };
};

let cached: RegionConfig | null = null;

/**
 * Fetches region config from the BFF (GET /config/region?country=XX) and caches it in memory.
 * Call after auth config is ready (e.g. from main.tsx after config.json).
 * Does not block: run fire-and-forget so the app renders with fallback locale until fetch completes.
 */
export async function fetchRegionConfig(country: string): Promise<RegionConfig | null> {
  const { baseUrl } = getAuthConfig();
  if (!baseUrl) {
    return null;
  }
  const url = `${baseUrl.replace(/\/$/, "")}/config/region?country=${encodeURIComponent(country)}`;
  try {
    const res = await fetch(url);
    if (!res.ok) {
      return null;
    }
    const data = (await res.json()) as RegionConfig;
    cached = data;
    return data;
  } catch {
    return null;
  }
}

/**
 * Returns the cached region config, or null if not yet fetched or fetch failed.
 */
export function getRegionConfig(): RegionConfig | null {
  return cached;
}
